<template>
  <div class="row header">
    <div class="col-lg-12">
      <p class="text-center">

        <img src="../assets/logo.png" class="logo">
      </p>
      <h1>
        {{ $t("message.title") }}
     </h1>
    </div>
    <!-- <div class="col-lg-12">
      <div class="version">
        <span>v.0.8.1 / 2019-04-24</span>
      </div>
    </div> -->
    <div class="col-lg-12">
      <div class="clause">
        <strong><span>{{ $t("message.clause1")}}</span></strong><br>
        <span>{{ $t("message.clause2")}}</span>
        <strong><span>{{ $t("message.clause3", {version: version.version.numer, data_start: version.version.data}) }}</span></strong>
        <span>{{ $t("message.clause4")}}</span><br>
        <!-- <span>{{ $t("message.clause5", {data:dzis()}) }}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "Header",
  data() {
    return {
      msg: "Header",
      info: '',
    };
  },
  computed: {
     ...mapState(['version'])
  },
  methods:{
    leadingZero(i) {
      return (i < 10)? '0'+i : i;
    },
    dzis(){
      var currentDate = new Date();
      return this.leadingZero(currentDate.getDate()) + "." + this.leadingZero(currentDate.getMonth()+1) + "." + currentDate.getFullYear();
    }
  },
  mounted () {
    this.$store.dispatch('version/load_version')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

.header {
  margin-bottom: 20px;
  h1 {
    font-size: 1.2em;
    text-align: center;
    font-weight: 700;
    @media (min-width: 576px) {
      font-size: 1.3em;
    }
  }
  .version {
    font-size: 0.6em;
    text-align: center;
    @media (min-width: 576px) {
      font-size: 0.8em;
    }
  }
  .clause {
    font-size: 0.6em;
    text-align: center;
    @media (min-width: 576px) {
      font-size: 0.7em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue